import React from "react"
import styled from "styled-components"
import { connect } from "react-redux"
import { withStyles } from "@material-ui/core/styles"
import TextField from "@material-ui/core/TextField"

import InputLabel from "@material-ui/core/InputLabel"
import FormControl from "@material-ui/core/FormControl"
import Select from "@material-ui/core/Select"
import MenuItem from "@material-ui/core/MenuItem"

import { fetchData, showToast, setHeaderTitle } from "../store/action"
import { emailRegex } from "../util/regExp"
import PageHeader from "./PageHeader"
import PrimaryButton from "../components/buttons/PrimaryButton"
import config from "../Config"
import { event } from "../components/reactGA"
import i18n from "../i18n"
import { I18nContext } from "react-i18next"
import Cookie from "../util/Cookie"

const Body = styled.div`
  height: calc(100% - 56px);
  overflow-y: scroll;
  overflow-x: hidden;
  padding-left: 10px;
  padding-right: 10px;
  background: #1c1d23;
`

const ImgBox = styled.div`
  margin-top: 10px;
  margin-bottom: 10px;
`

const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
  margin: 10px;
  background-color: transparent;
`

const formId = "contact-us-form"

const styles = (theme) => ({
  textField: {
    marginBottom: theme.spacing.unit * 2,
  },
  bootstrapInput: {
    // border: "1px solid #121316;",
    border: "none",
    borderRadius: "6px",
    // backgroundColor: "#16171b",
    backgroundColor: "none",
    fontSize: 16,
    // padding: "10px 12px",
    padding: "10px 5px",
    color: "rgba(255, 255, 255, 0.2)",
    width: "calc(100% - 24px)",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      border: "none",
      outline: "none",
      color: "rgba(255, 255, 255, 0.7)",
    },
  },
  bootstrapFormLabel: {
    fontSize: 14,
    color: "#fff",
    fontFamily: "montserratLight!important",
    "&$focus": {
      color: "red",
      fontWeight: "bold",
    },
  },
  // focusBootstrapFormLabel: {
  //   color: "rgba(255, 255, 255, 0.9)",
  // },
  bootstrapFormOptionLabel: {
    fontSize: 14,
    textAlign: "left",
    color: "rgba(255, 255, 255, 0.2)",
    padding: "5px",
  },
})

const QueryType = [
  { label: "Customer Query", value: "customerQuery" },
  { label: "Suggestion", value: "suggestion" },
  { label: "Complaint", value: "complaint" },
]

class ContactUs extends React.Component {
  constructor(props) {
    super(props)
    this.initializeState = this.initializeState.bind(this)
    this.state = {
      currentMessageLen: 0,
      ...this.initializeState(),
    }
    this.onSubmit = this.onSubmit.bind(this)
  }

  componentWillMount() {
    this.props.setHeaderTitle("Contact Us")
    const locale = Cookie.get("X-Reycreo-Language-Id")
    i18n.changeLanguage(locale || "en")
    console.log("RENDER ContactUs :: ", locale)
  }

  initializeState() {
    return {
      submitBtnStatus: false,
      name: "",
      email: "",
      queryType: "",
      message: "",
    }
  }

  handleButtonChange() {
    const { email, queryType, message, name } = this.state
    let submitBtnStatus = false
    //    if(name && email && mailRegex.email.test(email) && message && queryType){
    //       submitBtnStatus = true;
    //  }
    // this.setState({file, submitBtnStatus})
  }

  onInputChange(fieldName, value, invalidEmail) {
    let newStateData = { ...this.state, [fieldName]: value }
    const { email, queryType, message, name } = newStateData
    let submitBtnStatus = false

    if (name && email && emailRegex.email.test(email) && message && queryType) {
      submitBtnStatus = true
    }
    this.setState({
      [fieldName]: value,
      submitBtnStatus,
      invalidEmail,
    })
  }

  handleInputChange = (name) => (event) => {
    this.setState({
      [name]: event.target.value,
    })
  }

  onSubmit(e) {
    e.preventDefault()
    const { name, email, message, queryType } = this.state
    const { showToast, fetchData } = this.props
    if (!name) {
      showToast({
        text: i18n.t("NameCantBeEmpty"),
        variant: "warning",
      })
      return
    }

    if (!emailRegex.email.test(email)) {
      showToast({
        text: i18n.t("InvalidEmailAddress"),
        variant: "warning",
      })
      return
    }

    if (!queryType) {
      showToast({
        text: i18n.t("SelectQueryType"),
        variant: "warning",
      })
      return
    }

    if (!message) {
      showToast({
        text: i18n.t("MessageCantBeEmpty"),
        variant: "warning",
      })
      return
    }

    fetchData({
      method: "POST",
      uri: "/contactus/",
      withUserCredentials: true,
      body: {
        name,
        email,
        message,
        type: queryType,
      },
      onSuccess: (res) => {
        this.setState(this.initializeState())
        showToast({
          text: i18n.t("QuerySuccessfullySubmitted"),
        })
        event({
          category: "Contact Us Page",
          action: "Submit Query",
        })
      },
    })
  }

  messageLengthHandler = (message) => {
    let currentMessageLength = message.length
    this.setState({
      currentMessageLen: currentMessageLength,
    })
  }

  render() {
    const { classes } = this.props
    const {
      name,
      email,
      message,
      submitBtnStatus,
      queryType,
      currentMessageLen,
    } = this.state

    console.log("currentMessageLen", currentMessageLen)
    let maxMessageLength = 255
    maxMessageLength = maxMessageLength - currentMessageLen
    console.log("maxMessageLength", maxMessageLength)

    return (
      <div className='wrapper'>
        <PageHeader backLocation={"/play/"} label={i18n.t("ContactUs")} />
        <Body>
          <ImgBox className='text-center'>
            <img
              src={`${config.MRBIDNWIN_S3_IMAGE_URL}/message.svg`}
              alt='contact-us'
            />
          </ImgBox>
          <form id={formId} onSubmit={this.onSubmit}>
            {/*  data-required used instead of required below and all places in this page */}
            <FormWrapper>
              <TextField
                fullWidth
                id='name'
                label={i18n.t("Name")}
                type='text'
                placeholder={i18n.t("Enter your full name")}
                InputLabelProps={{
                  shrink: true,
                }}
                className={classes.textField}
                value={name}
                onChange={(e) => {
                  this.onInputChange("name", e.target.value)
                }}
                data-required={true}
                InputProps={{
                  // disableUnderline: true,
                  classes: {
                    root: classes.bootstrapRoot,
                    input: classes.bootstrapInput,
                  },
                }}
                InputLabelProps={{
                  // shrink: true,
                  className: classes.bootstrapFormLabel,
                  // focused: classes.focusBootstrapFormLabel
                }}
              />
              <TextField
                id='email'
                label={i18n.t("Email Address")}
                type='text'
                placeholder={i18n.t("Enter your email address")}
                InputLabelProps={{
                  shrink: true,
                }}
                className={classes.textField}
                value={email}
                onChange={(e) => {
                  this.onInputChange(
                    "email",
                    e.target.value,
                    !emailRegex.email.test(e.target.value)
                  )
                }}
                data-required={true}
                InputProps={{
                  // disableUnderline: true,
                  classes: {
                    root: classes.bootstrapRoot,
                    input: classes.bootstrapInput,
                  },
                }}
                InputLabelProps={{
                  // shrink: true,
                  className: classes.bootstrapFormLabel,
                }}
              />
              <FormControl data-required className={classes.textField}>
                <InputLabel
                  htmlFor='type-required'
                  classes={{
                    // shrink: true,
                    root: classes.bootstrapFormLabel,
                  }}
                >
                  {i18n.t("Type")}
                </InputLabel>
                <Select
                  value={queryType}
                  name='type'
                  onChange={(e) => {
                    this.onInputChange("queryType", e.target.value)
                  }}
                  inputProps={{
                    id: "type-required",
                  }}
                  classes={{
                    root: classes.bootstrapFormOptionLabel,
                  }}
                >
                  {QueryType.map((el) => {
                    return (
                      <MenuItem key={el.value} value={el.value}>
                        {i18n.t(el.label)}
                      </MenuItem>
                    )
                  })}
                </Select>
              </FormControl>
              <TextField
                id='message'
                // label={i18n.t("MaxMessageLenDisplay")}
                label={`Message (${maxMessageLength} characters allowed)`}
                type='text'
                placeholder={i18n.t("Enter your message")}
                InputLabelProps={{
                  shrink: true,
                }}
                className={classes.textField}
                value={message}
                multiline={true}
                rows={4}
                rowsMax={5}
                onChange={(event) => {
                  const message = event.target.value
                  //   console.log("message length", message.length)
                  this.messageLengthHandler(message)
                  if (message.length > 254) return
                  this.setState({
                    message,
                  })
                  this.onInputChange("message", event.target.value)
                }}
                data-required={true}
                InputProps={{
                  // disableUnderline: true,
                  classes: {
                    root: classes.bootstrapRoot,
                    input: classes.bootstrapInput,
                  },
                }}
                InputLabelProps={{
                  // shrink: true,
                  className: classes.bootstrapFormLabel,
                }}
              />
              <div className='text-center'>
                <PrimaryButton
                  style={{
                    marginBottom: 10,
                    height: 54,
                    color: "#fff",
                    width: "75%",
                    border: "none",
                    borderRadius: "22px",
                    backgroundColor: submitBtnStatus ? "#fb0e56" : "#808080c9",
                  }}
                  formId={formId}
                  variant='contained'
                  label={i18n.t("Submit")}
                  type='submit'
                  disabled={!submitBtnStatus}
                />
              </div>
            </FormWrapper>
          </form>
        </Body>
      </div>
    )
  }
}

ContactUs = connect(
  (state, ownProps) => {
    return {}
  },
  {
    fetchData,
    showToast,
    setHeaderTitle,
  }
)(withStyles(styles)(ContactUs))

export default ContactUs



// WEBPACK FOOTER //
// ./src/views/ContactUs.js